const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

// 日志
const operatorLog = r =>
  require.ensure(
    [],
    () => r(require('@/modules//zkCdpPage/monitor/operatorLog.vue')),
    'monitor'
  )

const loginLog = r =>
  require.ensure(
    [],
    () => r(require('@/modules//zkCdpPage/monitor/loginLog.vue')),
    'monitor'
  )

const ApiLog = r =>
  require.ensure(
    [],
    () => r(require('@/modules/developer/ApiLog/ApiLog.vue')),
    'monitor'
  )

const pushLog = r =>
  require.ensure(
    [],
    () => r(require('@/modules/developer/pushLog.vue')),
    'monitor'
  )

const communicationLog = r =>
  require.ensure(
    [],
    () =>
      r(
        require('@/modules/enterpriseAdmin/deviceManager/communicationLog.vue')
      ),
    'enterpriseAdmin'
  )

const devicesCommand = r =>
  require.ensure(
    [],
    () =>
      r(require('@/modules/enterpriseAdmin/deviceManager/devicesCommand.vue')),
    'enterpriseAdmin'
  )

const monitorRouter = {
  path: '/monitor',
  name: 'monitor',
  component: Layout,
  meta: {
    id: 'sys-menu-d',
    auth: true
  },
  redirect: '/monitor/operatorLog',
  children: [
    {
      path: 'operatorLog',
      name: 'operatorLog',
      component: operatorLog,
      meta: {
        id: 'sys-menu-d-1',
        auth: true
      }
    },
    {
      path: 'loginLog',
      name: 'loginLog',
      component: loginLog,
      meta: {
        id: 'sys-menu-d-2',
        auth: true
      }
    },
    {
      path: 'apiLog',
      name: 'apiLog',
      component: ApiLog,
      meta: {
        id: '5f00f696797d4e92a33c45a5c050b8f5',
        auth: true
      }
    },
    {
      path: 'pushLog',
      name: 'pushLog',
      component: pushLog,
      meta: {
        id: 'dc9f675c1b364b56b430b6a989c8bcf1',
        auth: true
      }
    },

    {
      path: 'communicationLog',
      name: 'communicationLog',
      component: communicationLog,
      meta: {
        id: '022b05061caa4f4fa6e8f810e73cf92e',
        auth: true
      }
    },
    {
      path: 'devicesCommand',
      name: 'devicesCommand',
      component: devicesCommand,
      meta: {
        id: 'ea2d0ea36285498998ed48e525906309',
        auth: true
      }
    }
  ]
}
export default monitorRouter



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/monitor.js